/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceDto } from '../../models/device-dto';
import { UpdateDeviceAutoUpdateDto } from '../../models/update-device-auto-update-dto';

export interface DeviceControllerUpdateAutoUpdatePolicy$Params {
  deviceId: string;
  clientWorkspaceId: string;
      body: UpdateDeviceAutoUpdateDto
}

export function deviceControllerUpdateAutoUpdatePolicy(http: HttpClient, rootUrl: string, params: DeviceControllerUpdateAutoUpdatePolicy$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerUpdateAutoUpdatePolicy.PATH, 'patch');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceDto>;
    })
  );
}

deviceControllerUpdateAutoUpdatePolicy.PATH = '/api/device/{clientWorkspaceId}/{deviceId}/auto-update';
